import React from "react";
import { Img } from "../../core/design-system/Img";
import { Text } from "../../core/design-system/Text";
import Button from "../../core/design-system/Button/Button";
import { useOpenBanking } from "../../location/context/OpenBankingContext";

const EnableOpenBanking: React.FC = () => {
  const { isOpenBanking, toggleOpen} = useOpenBanking();
  if (isOpenBanking) return <></>;
  return (
    <div className="w-full flex flex-row rounded-lg bg-registerDebtBackground p-5 justify-start gap-2 items-center ">
      <div className="w-1/4">
        <Img src={"bank.svg"} className="w-[83px] h-[83px]" alt="wallet" />
      </div>
      <div className="w-3/4 flex flex-row items-center">
        <div className="flex flex-col p-3">
          <Text className="text-black font-normal text-left" size="lg">
            {`Enable Open Banking`}
          </Text>
          <Text className="text-grey text-[14px] font-normal text-left">
            {`Track your finance across all your other banks accounts`}
          </Text>

          <Button
            className="bg-primary mt-2"
            size={"default"}
            onClick={toggleOpen}
          >
            Enable
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EnableOpenBanking;
